export const selectEntityData = state => state.entity
